import SubmittedFormViewContainer from "./SubmittedFormView.Container";

export default SubmittedFormViewContainer;
